import { useEffect, useState } from 'react'
import { MaybeAlertType, WrapperProps } from '../components'
import { DEFAULT_CLEAR_ALERTS_TIMEOUT_MS } from '../constants'
import { createContextFactory } from './utils'

export interface AlertData {
  alertType: MaybeAlertType
  setAlertType: (alertType: MaybeAlertType) => void
}

const [useAlert, AlertContextProvider] = createContextFactory<AlertData>(
  'useAlert',
  'AlertContextProvider'
)

interface AlertProviderProps extends WrapperProps {
  clearAlerts?: boolean
}

const AlertProvider = ({
  children,
  clearAlerts = false
}: AlertProviderProps) => {
  const [alertType, setAlertType] = useState<MaybeAlertType>(undefined)

  useEffect(() => {
    if (alertType) {
      setAlertType(alertType)
      if (clearAlerts) {
        const id = setTimeout(() => {
          setAlertType(undefined)
        }, DEFAULT_CLEAR_ALERTS_TIMEOUT_MS)
        return () => clearTimeout(id)
      }
    }
  }, [alertType, clearAlerts])

  return (
    <AlertContextProvider
      value={{
        alertType,
        setAlertType
      }}
    >
      {children}
    </AlertContextProvider>
  )
}

export { AlertProvider, useAlert }
